/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workspace_Vertical_StackInputs */

const en_workspace_vertical_stack = /** @type {(inputs: Workspace_Vertical_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertical Stack`)
};

const fr_workspace_vertical_stack = /** @type {(inputs: Workspace_Vertical_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empilement vertical`)
};

const de_workspace_vertical_stack = /** @type {(inputs: Workspace_Vertical_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertikaler Stapel`)
};

const it_workspace_vertical_stack = /** @type {(inputs: Workspace_Vertical_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pila verticale`)
};

const ru_workspace_vertical_stack = /** @type {(inputs: Workspace_Vertical_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вертикальная стопка`)
};

const es_workspace_vertical_stack = /** @type {(inputs: Workspace_Vertical_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pila vertical`)
};

const zh_cn2_workspace_vertical_stack = /** @type {(inputs: Workspace_Vertical_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`垂直堆叠`)
};

const ja_workspace_vertical_stack = /** @type {(inputs: Workspace_Vertical_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`垂直スタック`)
};

const hi_workspace_vertical_stack = /** @type {(inputs: Workspace_Vertical_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्टिकल स्टैक`)
};

const pt_pt2_workspace_vertical_stack = /** @type {(inputs: Workspace_Vertical_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilha vertical`)
};

/**
* | output |
* | --- |
* | "Vertical Stack" |
*
* @param {Workspace_Vertical_StackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const workspace_vertical_stack = /** @type {((inputs?: Workspace_Vertical_StackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workspace_Vertical_StackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_workspace_vertical_stack(inputs)
	if (locale === "de") return de_workspace_vertical_stack(inputs)
	if (locale === "it") return it_workspace_vertical_stack(inputs)
	if (locale === "ru") return ru_workspace_vertical_stack(inputs)
	if (locale === "es") return es_workspace_vertical_stack(inputs)
	if (locale === "zh-CN") return zh_cn2_workspace_vertical_stack(inputs)
	if (locale === "ja") return ja_workspace_vertical_stack(inputs)
	if (locale === "hi") return hi_workspace_vertical_stack(inputs)
	if (locale === "pt-PT") return pt_pt2_workspace_vertical_stack(inputs)
	return en_workspace_vertical_stack(inputs)
});